<div class="flex w-full items-center gap-2" [ngClass]="additionalClasses">
    <p class="">{{ ratingNumber }} star</p>
    <div class="relative h-4 w-44 flex-grow rounded-full bg-evenlightergrey">
        <div
            class="absolute top-0 h-full rounded-full bg-color-blind-palette-yellow"
            [ngStyle]="{ width: ratingPercentage }"></div>
    </div>
    <p class="w-10 font-bold">{{ ratingPercentage }}</p>
</div>
